<template>
  <b-nav-item-dropdown>
    <template #button-content>
      <slot>
        Help
      </slot>
    </template>

    <b-dropdown-item
        target="_blank"
        v-for="route in routes"
        :key="route.label"
        :to="route.route"
        :href="route.href"
    >
      {{ route.label }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
export default {
  name: 'SupportMenu',
  data() {
    return {
      routes: [
        {
          label: 'Knowledge Hub',
          href: 'https://support.riskhub.co.uk/',
        },
        {
          label: 'Contact Support',
          href: 'https://support.riskhub.co.uk/kb-tickets/new',
        },
      ],
    };
  },
};
</script>
